<template>
  <b-table
    hover
    bordered
    :fields="fields"
    :items="items"
    :busy="isBusy"
    @row-clicked="onRowClicked"
  >
    <template slot="primary" slot-scope="{ item }">
      <b-form-checkbox disabled :checked="item.isPrimary" />
    </template>
    <template slot="active" slot-scope="{ item }">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <b-form-checkbox disabled :checked="item.isActive" />
        <span>{{ $dayjs(item.active_date).format('MMM D, YYYY') }}</span>
        <span> - </span>
        <span>{{ $dayjs(item.completion_date).format('MMM D, YYYY') }}</span>
      </div>
    </template>
    <template slot="hidden" slot-scope="{ item }">
      <b-form-checkbox disabled :checked="!!item.is_questionnaire_hidden" />
    </template>
  </b-table>
</template>

<script>
import GetMembershipTypeOptionsMixin from '@/mixins/GetMembershipTypeOptionsMixin';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';

const FIELDS = [
  { key: 'title' },
  {
    key: 'society',
    formatter: (value, key, item) =>
      `${item.society.name} (${item.society.url_code})`,
  },
  {
    key: 'study_type',
    formatter: (value, key, item) =>
      item.studyType ? item.studyType.name : '',
  },
  {
    key: 'membershipType',
    label: 'Memberships',
    class: 'text-center',
    formatter: (value, key, item) => {
      const typeList = item.societyMembershipTypes.reduce(
        (types, { type_name }) => {
          types.push(type_name);
          return types;
        },
        []
      );
      return typeList.join(', ');
    },
  },
  { key: 'primary', class: 'text-center' },
  { key: 'active', class: 'text-center' },
  { key: 'hidden', class: 'text-center' },
];

export default {
  name: 'QuestionnairesListByQuestion',
  mixins: [GetMembershipTypeOptionsMixin],
  props: {
    questionId: Number,
  },
  data: function () {
    return {
      items: [],
      isBusy: false,
    };
  },
  created: function () {
    this.getQuestionnaires();
  },
  computed: {
    fields: function () {
      return FIELDS;
    },
  },
  methods: {
    getQuestionnaires: async function () {
      this.isBusy = true;
      try {
        this.items = await Api.getQuestionnairesByQuestionId(this.questionId);
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.isBusy = false;
      }
    },
    onRowClicked: function ({ id = null }) {
      id && this.$router.push(`/admin/questionnaire/edit/${id}`);
    },
  },
  watch: {
    questionId: function () {
      this.getQuestionnaires();
    },
  },
};
</script>

<style lang="scss">
.table-hover {
  tbody {
    tr:hover {
      cursor: pointer;
    }
  }
}
</style>
